import axiosInstance from "config/AxiosConfig";
import {
  RetailPartnerListResp,
  RetailPartnerDetailResp,
  RetailPartnerDetailByOwnerResp,
  RetailPartnerListByOwnerResp,
  RetailPartnerDetailFullResp,
} from "domain/payload/response/retailPartner/RetailPartnerResp";
import { RetailPartnerCreateReq } from "domain/payload/request/retailPartner/RetailPartnerCreateReq";
import { RetailPartnerUpdateReq } from "domain/payload/request/retailPartner/RetailPartnerUpdateReq";
import { BaseResponse } from "domain/payload/response/BaseResponseDto";

const RetailPartnerService = () => {
  const getList = async (
    token: string,
    page?: number,
    size?: number,
    search?: string | null
  ): Promise<RetailPartnerListResp> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/merchant-partner/by-store/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            page,
            size,
            search,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const getDetail = async (
    token: string,
    id: string
  ): Promise<RetailPartnerDetailFullResp> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/merchant-partner/by-store/detail`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const insert = async (
    token: string,
    request: RetailPartnerCreateReq
  ): Promise<RetailPartnerDetailResp> => {
    try {
      const response = await axiosInstance.post(
        `/v1/legacy/cms/merchant-partner/create`,
        request,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const update = async (
    token: string,
    request: RetailPartnerUpdateReq
  ): Promise<RetailPartnerDetailResp> => {
    try {
      const response = await axiosInstance.put(
        `/v1/legacy/cms/merchant-partner/update`,
        request,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const remove = async (
    token: string,
    id: string
  ): Promise<RetailPartnerDetailResp> => {
    try {
      const response = await axiosInstance.delete(
        `/v1/legacy/cms/merchant-partner/delete`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const getListByOwner = async (
    token: string,
    page?: number,
    size?: number,
    search?: string | null
  ): Promise<BaseResponse<RetailPartnerListByOwnerResp[]>> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/merchant-partner/by-user/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            page,
            size,
            search,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const getDetailByOnwer = async (
    token: string,
    id: string
  ): Promise<RetailPartnerDetailByOwnerResp> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/merchant-partner/by-user/detail`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return { getList, getDetail, insert, update, remove, getListByOwner, getDetailByOnwer };
};

export default RetailPartnerService;
